import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';

export interface PromotionCountFilters {
    inclusion: { attributeType: string; attributeId: string }[];
    exclusion: { attributeType: string; attributeId: string }[];
}

interface PromotionCountResponse {
    total_count: number;
}

const fetchPromotionCount = async (
    planId: string,
    filters: PromotionCountFilters,
    startDate: number,
    signal?: AbortSignal,
): Promise<PromotionCountResponse> => {
    const response = await axios(tpoGenUrls.getPromotionCount, {
        method: 'POST',
        data: {
            plan_id: planId,
            filters,
            start_date: startDate, //  need to change key to optimization_start_date
        },
        signal,
    });
    return response.data;
};

const usePromotionCount = ({
    planId,
    filters,
    startDate,
    enabled,
}: {
    planId: string;
    filters: PromotionCountFilters;
    startDate: number | null;
    enabled: boolean;
}) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: tpoGenKeys.promotionCount(planId, filters, startDate),
        queryFn: ({ signal }) => fetchPromotionCount(planId, filters, startDate!, signal),
        enabled: enabled && Boolean(planId) && startDate != null,
        refetchOnWindowFocus: false,
    });

    return {
        promotionTotalCount: data?.total_count ?? 0,
        promotionCountLoading: isLoading,
        promotionCountError: isError,
    };
};

export default usePromotionCount;
